module.exports = __webpack_public_path__ + "assets/mobile_settings-bc95ee.svg";